import { Card, Row, Col, Typography, Input, Empty } from "antd";
import { CalendarOutlined, EnvironmentOutlined, RiseOutlined, AppstoreOutlined, BarChartOutlined, DollarOutlined } from "@ant-design/icons";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { reportApi, Report } from "@/services/api/reports";
import { useState, useMemo } from "react";

const { Title, Text } = Typography;
const { Search } = Input;

const staticModules = [
  { title: "SPU排产日历", url: "/sku-calendar", icon: <CalendarOutlined style={{ fontSize: 28, color: "#1890ff" }} />, description: "SPU 排产计划与日历视图" },
  { title: "物流监控", url: "/logistics", icon: <EnvironmentOutlined style={{ fontSize: 28, color: "#52c41a" }} />, description: "物流地图与在途监控" },
  { title: "备货预测", url: "/InventoryForecast", icon: <RiseOutlined style={{ fontSize: 28, color: "#fa8c16" }} />, description: "库存与备货预测分析" },
  { title: "在售商品情况", url: "/OnSaleProducts", icon: <AppstoreOutlined style={{ fontSize: 28, color: "#722ed1" }} />, description: "在售商品层级与销量" },
  { title: "在售商品分类", url: "/OnSaleSpuProducts", icon: <AppstoreOutlined style={{ fontSize: 28, color: "#eb2f96" }} />, description: "在售商品分类视图" },
  { title: "预测MAPE情况", url: "/forecast-map-status", icon: <BarChartOutlined style={{ fontSize: 28, color: "#13c2c2" }} />, description: "预测 MAPE 状态看板" },
  { title: "FCST与预算比较", url: "/financial-spu-budget-comparison", icon: <DollarOutlined style={{ fontSize: 28, color: "#fa8c16" }} />, description: "FCST与预算比较分析" },
];

export default function BusinessModules() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const keywordFromUrl = searchParams.get("q") || "";
  const [keyword, setKeyword] = useState(keywordFromUrl);

  const { data: reports = [] } = useQuery<Report[]>({
    queryKey: ["reports"],
    queryFn: () => reportApi.getReports({ page_size: 50, page_no: 1, searchId: null }),
  });

  const reportCards = useMemo(
    () =>
      reports.map((r: Report) => ({
        title: r.name,
        url: `/report/${r.search_id}`,
        icon: <BarChartOutlined style={{ fontSize: 28, color: "#1890ff" }} />,
        description: "可视化报表",
      })),
    [reports]
  );

  const allModules = [...staticModules, ...reportCards];
  const filtered = useMemo(() => {
    if (!keyword.trim()) return allModules;
    const k = keyword.trim().toLowerCase();
    return allModules.filter((m) => m.title.toLowerCase().includes(k));
  }, [keyword, allModules]);

  return (
    <div>
      <div style={{ marginBottom: 28, display: "flex", flexWrap: "wrap", gap: 16, alignItems: "center" }}>
        <Title level={3} className="tech-page-title" style={{ margin: 0, fontSize: 22 }}>
          业务模块
        </Title>
        <Search
          placeholder="搜索模块名称..."
          allowClear
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          onSearch={(v) => setKeyword(v)}
          style={{ width: 280 }}
        />
      </div>
      <Row gutter={[20, 20]}>
        {filtered.length === 0 ? (
          <Col span={24}>
            <Empty description="暂无匹配模块" />
          </Col>
        ) : (
          filtered.map((m) => (
            <Col xs={24} sm={12} md={8} lg={6} key={m.title + m.url}>
              <Card
                hoverable
                onClick={() => navigate(m.url)}
                className="tech-card"
                style={{ cursor: "pointer", height: "100%", borderRadius: 12 }}
                bodyStyle={{ padding: 24 }}
              >
                <div style={{ textAlign: "center", marginBottom: 16 }}>
                  <span className="tech-icon-wrap">{m.icon}</span>
                </div>
                <Title level={5} style={{ marginBottom: 8, textAlign: "center", fontWeight: 600 }}>
                  {m.title}
                </Title>
                <Text type="secondary" style={{ fontSize: 12, display: "block", textAlign: "center" }}>
                  {m.description}
                </Text>
              </Card>
            </Col>
          ))
        )}
      </Row>
    </div>
  );
}
